<template>
  <div class="detail-container">
    <commonHeader>
      <img slot="content" class="banner_img" :src="bannerImg | imgFilter" />
      <banner-content
        slot="content"
        enTitle="PRODUCT CASES"
        title="产品案例"
        content="拥有丰富的项目经验，以最短的时间开发出高性能的产品<br/>用自主开发的软件框和前沿技术研发而成<br/>保持了原有的稳定高效的特点，更提高了框架的安全性和可扩展性"
      />
    </commonHeader>

    <div class="detail-content">
      <div class="title">{{ current.title }}</div>
      <div class="content" v-html="current.content" />
    </div>
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader.vue';
import { newsDetail } from '@/api';
import BannerContent from '@/components/bannerContent.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: { BannerContent, commonHeader },
  data() {
    return {
      id: 0,
      current: {},
      next: {},
      up: {},
    };
  },
  computed: {
    ...mapGetters('banner', ['banner']),
    bannerImg() {
      let arr = this.banner(3);
      return arr.length ? arr[0].carousel_image : '';
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.init(this.id);
    if (!this.banner(3).length) this.getBanner(3);
  },
  methods: {
     ...mapActions("banner", ["getBanner"]),

    async init(news_id) {
      const res = await newsDetail({ news_id }).catch((e) => false);
      if (!res || res.code != 200) return;
      console.log(res);
      this.current = res.data.current;
      this.next = res.data.next;
      this.up = res.data.up;
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.detail-container {
  min-height: 100vh;
  width: 100%;
  img {
    width: 100%;
  }
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .detail-content {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    .title {
      font-weight: bold;
      font-size: 30px;
      text-align: center;
      margin-top: 3%;
    }
    .content {
      width: 100%;
      padding: 3% 20%;
      box-sizing: border-box;
      ::v-deep p {
        margin: 0;
        padding: 0;
      }
      ::v-deep img {
        width: 100%;
        vertical-align: top;
      }
    }
    .footer {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
